module.exports = __webpack_public_path__ + "img/login-background.1b1135d8.jpg";